import { useAct } from 'DashboardUser/store'
import OrganisationPickerModal from 'Shared/components/OrganisationPicker/OrganisationPickerModal'
import AddFilter from './AddFilter'
import FilterConfiguration from './FilterConfiguration';
import { FilterPopover, FilterPopoverContent, FilterPopoverWrapped} from './FilterPopover'

export default function AddFilterPill() {
    const act = useAct()
    const [isOpen, setIsOpen] = useState(false)
    const [selectedFilterKey, setSelectedFilterKey] = useState(null)
    const [orgPickerOpen, setOrgPickerOpen] = useState(false)

    const togglePopup = (forceClose = false) => {
        setSelectedFilterKey(null);
        setIsOpen(forceClose ? false : !isOpen);
    }

    const openOrgPicker = () => {
        togglePopup(true);
        setOrgPickerOpen(true);
    }

    return <>
        <FilterPopover isOpen={isOpen} filterKey={selectedFilterKey} closePopup={() => togglePopup(true)}>
            <FilterPopoverContent>
                { selectedFilterKey ? <FilterConfiguration filterKey={selectedFilterKey} closeConfiguration={() => togglePopup(true)} hideSorting={true} /> : <AddFilter selectFilterKey={setSelectedFilterKey} openOrgPicker={openOrgPicker} /> }
            </FilterPopoverContent>
            <FilterPopoverWrapped className="add-filters">
                <button className="pill ghost" onClick={() => togglePopup()}>
                    + Add filter
                </button>
            </FilterPopoverWrapped>
        </FilterPopover>
        {orgPickerOpen && <OrganisationPickerModal
            open={true}
            hide={() => setOrgPickerOpen(false)}
            onPick={(id) => {
                act.local.setFilter('organisation_id', String(id));
                setOrgPickerOpen(false);
            }}
        />}
    </>
}
